module.exports = __webpack_public_path__ + "static/media/Frame2.320ab664.png";